import { Modal } from 'antd';
import DocListModal from 'pages/Document/DocListModal';
import React from 'react';
import { DocSelectedType } from './DocSelect';

export type DocSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setDoc?: (
    Doc: DocSelectedType
  ) => void;
};

const DocSearchModal = ({
  onCancel,
  visible,
  setDoc,
}: DocSearchModalProps) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <DocListModal
        onSelect={setDoc}
      />
    </Modal>
  );
};

export default DocSearchModal;
